module.exports = __webpack_public_path__ + "img/logo.2b8a25f0.png";